import moment from 'moment-timezone';
import * as _ from '../lodash';
import { createReservation, getAvailability } from '../services/api';

export const SET_DATE_RANGE = 'SET_DATE_RANGE';
export const SET_ORDER_DETAILS = 'SET_ORDER_DETAILS';
export const SET_SELECTED_OPTION = 'SET_SELECTED_OPTION';
export const SET_SELECTED_VARIANT = 'SET_SELECTED_VARIANT';
export const SET_SELECTED_TERM = 'SET_SELECTED_TERM';
export const SET_TIMESLOT = 'SET_TIMESLOT';
export const SET_SELECTED_LOCATION = 'SET_SELECTED_LOCATION';
export const SET_SELECTED_RESOURCE = 'SET_SELECTED_RESOURCE';
export const SET_BOOKING_FIELDS = 'SET_BOOKING_FIELDS';
export const SET_BOOKINGS = 'SET_BOOKINGS';
export const SET_CURRENT_MONTH = 'SET_CURRENT_MONTH';
export const CHANGE_ADDITIONAL_DETAILS = 'CHANGE_ADDITIONAL_DETAILS';
export const ADD_REPEATED_FIELD_ITEMS = 'ADD_REPEATED_FIELD_ITEMS';
export const REMOVE_REPEATED_FIELD_ITEMS = 'REMOVE_REPEATED_FIELD_ITEMS';
export const SET_ADDITIONAL_DETAILS_VALIDATION_ERRORS = 'SET_ADDITIONAL_DETAILS_VALIDATION_ERRORS';

import { SHORT_DATE_FORMAT } from '../constants';

export const setOrderDetails = value => ({
  type: SET_ORDER_DETAILS,
  value,
});

export const setSelectedTimeslot = value => ({
  type: SET_SELECTED_OPTION,
  value,
});

export const setSelectedVariant = value => ({
  type: SET_SELECTED_VARIANT,
  value,
});

export const setSelectedLocation = value => ({
  type: SET_SELECTED_LOCATION,
  value,
});

export const setSelectedResource = value => ({
  type: SET_SELECTED_RESOURCE,
  value,
});

export const setTimeSlot = value => ({
  type: SET_TIMESLOT,
  value,
});

export const setDateRange = value => ({
  type: SET_DATE_RANGE,
  value,
});

export const setSelectedTerm = value => ({
  type: SET_SELECTED_TERM,
  value,
});

export const setBookingFields = value => ({
  type: SET_BOOKING_FIELDS,
  value,
});

export const changeAdditionalDetails = (field, value, index) => ({
  type: CHANGE_ADDITIONAL_DETAILS,
  field,
  value,
  index
});

export function onAddRepeatedFieldItems(fieldsSettings) {
  return {
    type: ADD_REPEATED_FIELD_ITEMS,
    fieldsSettings
  };
}

export function onRemoveRepeatedFieldItems(fieldsSettings, index) {
  return {
    type: REMOVE_REPEATED_FIELD_ITEMS,
    fieldsSettings,
    index
  };
}

export function onSetDetailsErrors(errors) {
  return {
    type: SET_ADDITIONAL_DETAILS_VALIDATION_ERRORS,
    errors
  };
}

export const setVariantsQuantity = (name, quantity, { singleVariant = false } = {}) => (dispatch, getState) => {
  let {
    product: { data },
    order: { variants, date },
  } = getState();

  const [externalId, type] = name.split('_');

  if (singleVariant) variants = {};

  let variant = variants[externalId];

  if (variant) {
    variant[type] = +quantity || 0;
  } else {
    variant = _.find(data.variants, x => `${x.external_id}` === `${externalId}`);
    variants[externalId] = {
      ...variant,
      field: type,
      [type]: +quantity || 0,
    };
  }
  dispatch(setSelectedVariant(+externalId));

  const totalQuantity = _.sum(_.map(variants, (_value, key) => variants[key].quantity * (variants[key].unit_multiplier || 1)));
  const totalPrice = _.sum(_.map(variants, (_value, key) => variants[key].quantity * variants[key].price));

  dispatch({
    type: SET_ORDER_DETAILS,
    value: {
      variants,
      totalQuantity,
      totalPrice,
    },
  });
};

export const resetVariantsQuantity = () => (dispatch, getState) =>  {
  let {
    product: { data },
    order: { variants, date },
  } = getState();
  
  const dateObj = date ? moment(date).toDate() : null;
  
  const seasonalRates = _.filter(data.seasonal_rates, (seasonalRate) => {
    const srStart = moment(seasonalRate.starts_at).toDate();
    const srFinish = moment(seasonalRate.finishes_at).toDate();
    return dateObj && dateObj >= srStart && dateObj <= srFinish;
  });

  _.forEach(variants, (value, externalId) => {
    const isAvailableVariant = _.some(seasonalRates, (seasonalRate) => {
      return seasonalRate.season == variants[externalId].options[0] && seasonalRate.rate == variants[externalId].options[1];
    });
    if (!isAvailableVariant) variants[externalId] = {...variants[externalId], quantity: 0};
  })
  
  const totalQuantity = _.sum(_.map(variants, (_value, key) => variants[key].quantity));
  const totalPrice = _.sum(_.map(variants, (_value, key) => variants[key].quantity * variants[key].price));

  dispatch({
    type: SET_ORDER_DETAILS,
    value: {
      variants,
      totalQuantity,
      totalPrice,
    },
  });
}

export const submitOrder = () => (_dispatch, getState) => {
  const {
    order: { date, selectedTimeslot, variants, selectedLocation },
    frames: { frames },
  } = getState();

  const frame = frames.find(x => x.date === date),
        selectedStart = typeof selectedTimeslot === "object" ? selectedTimeslot.start : selectedTimeslot,
        timeslot = frame.timeslots.find(x => x.start === selectedStart);

  const items = _.filter(variants, x => !!x.quantity).map(value => ({
    externalId: value.external_id,
    quantity: value.quantity,
    location_name: selectedLocation ? selectedLocation.name : null,
    start: timeslot.start,
  }));

  return createReservation(items);
};

export const submitClassOrder = () => (_dispatch, getState) => {
  const {
    order: { date, selectedTimeslot, variants, quantity=1, selectedLocation },
    frames: { frames },
  } = getState();

  const frame = frames.find(x => x.date === date),
        selectedStart = selectedTimeslot.start,
        timeslot = frame.timeslots.find(x => x.start === selectedStart);

  const items = _.filter(variants, x => !!x.quantity).map(value => ({
    externalId: value.external_id,
    quantity: quantity,
    location_name: selectedLocation ? selectedLocation.name : null,
    start: timeslot.start,
  }));

  return createReservation(items);
};

export const submitCourseOrder = () => (_dispatch, getState) => {
  const {
    order: { variantSelected, termSelected, selectedLocation },
    product: { data }
  } = getState();

  const duration = data.duration,
        startDate = termSelected.start_date;

  let finishDate = termSelected.finish_date;

  if (moment(startDate).format() != moment(finishDate).subtract(duration, 'seconds').format()) {
    finishDate = moment(finishDate).add(duration, 'seconds').format()
  }

  const items = [
    {
      externalId: variantSelected,
      quantity: 1,
      location_name: selectedLocation ? selectedLocation.name : null,
      start: moment
        .tz(startDate, window.bta.timeZone)
        .utc()
        .format(),
      finish: moment
        .tz(finishDate, window.bta.timeZone)
        .utc()
        .format(),
    },
  ];

  return createReservation(items);
};

export const submitAppointment = () => (_dispatch, getState) => {
  const {
    order: { variantSelected, selectedLocation, selectedResource, timeSlot, bookingFields, quantity = 1 },
  } = getState();

  const items = [
    {
      externalId: variantSelected,
      quantity: quantity,
      resource_name: selectedResource ? selectedResource.name : null,
      location_name: selectedLocation ? selectedLocation.name : null,
      start: moment
        .tz(timeSlot.timeSlot.start, window.bta.timeZone)
        .utc()
        .format(),
      finish: moment
        .tz(timeSlot.timeSlot.finish, window.bta.timeZone)
        .utc()
        .format(),
      fields: bookingFields,
    },
  ];
  return createReservation(items);
};


export const submitRentalOrder = () => (_dispatch, getState) => {
  const {
    order: { variantSelected, dateRange, bookingFields, selectedLocation }
  } = getState();

  const items = [
    {
      externalId: variantSelected,
      quantity: 1,
      start: dateRange.start,
      finish: dateRange.finish,
      duration: dateRange.duration,
      fields: bookingFields,
      location_name: selectedLocation ? selectedLocation.name : null,
    },
  ];
  return createReservation(items);
};
